const Company = [
  {
    path: '/my_company',
    name: 'MyCompany',
    redirect: '/my_company/settings',
    meta: { 
      auth: true, 
      needs_company: true,
      tab_name: 'Minha Empresa',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/company_settings/CompanySettings.vue`),
    children: [ 
      {
        path: 'settings',
        name: 'MyCompanySettings',
        meta: { 
          auth: true, 
          needs_company: true,
          tab_name: 'Configurações da empresa',
        },
        component: () => import('@/components/company/RegisterCompany.vue'),
      },
      {
        path: 'financial_reserve',
        name: 'MyCompanyFinancialReserve',
        meta: { 
          auth: true, 
          needs_company: true,
          tab_name: 'Reserva do mês',
        },
        component: () => import('@/components/company/CompanyFinancialReserve.vue'),
      },
      {
        path: 'financial_goal',
        name: 'MyCompanyFinancialGoal',
        meta: { 
          auth: true, 
          needs_company: true,
          tab_name: 'Meta do mês',
        },
        component: () => import('@/components/company/CompanyFinancialGoal.vue'),
      },
      {
        path: 'member_list',
        name: 'MyCompanyMemberList',
        meta: { 
          auth: true, 
          needs_company: true,
          tab_name: 'Lista de membros',
        },
        component: () => import('@/components/member/MemberList.vue'),
        children: [
          {
            //path: '/members/:id',
            path: 'edit_member_role/:id',
            name: 'EditMember',
            meta: { 
              auth: true, 
              tab_name: 'Adicionar Membro',
              // roles: [Director, Manager, Supervisor],
            },
            component: () => import('@/components/member/members/EditMemberRole.vue'),
          },
        ]
      },
    ]
  },
  // {
  //   path: '/company_info',
  //   name: 'CompanyInfo',
  //   meta: { 
  //     auth: true, 
  //     tab_name: 'Informações da Empresa',
  //     // roles: [Director, Manager, Supervisor],
  //   },
  //   //component: () => import(`@/pages/company/CreateCompany.vue`)
  // },
  // {
  //   path: '/company_financial_config',
  //   name: 'CompanyFinancialConfig',
  //   meta: { 
  //     auth: true, 
  //     tab_name: 'Configurações financeiras',
  //     // roles: [Director, Manager, Supervisor],
  //   },
  //   // component: () => import(`@/pages/company/ShowEvent.vue`)
  // },
  
]

export default Company
